import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { storageApiRef, useApi } from '@backstage/core-plugin-api';

import { useAuth } from '../auth-factory';
import { useStorageKey } from './useStorageKey';

export type RecentlyVisitedItem = {
  route: string;
  title: string;
};

export function useRecentlyVisited() {
  const location = useLocation();
  const storage = useApi(storageApiRef);
  const { orgName: workspaceId } = useAuth();
  const userStorageKey = useStorageKey('recentlyVisited');
  const key = workspaceId ? `${userStorageKey}-${workspaceId}` : undefined;

  const triggerRecentlyVisited = useCallback(
    (title: string) => {
      if (!key) return;

      const item = { title, route: location.pathname };
      const recentlyVisited = storage.snapshot<RecentlyVisitedItem[]>(key);
      if (Array.isArray(recentlyVisited.value)) {
        const newValue = [
          item,
          ...recentlyVisited.value.filter(v => v.route !== item.route),
        ].slice(0, 9);
        storage.set(key, newValue);
      } else {
        storage.set(key, [item]);
      }
    },
    [key, location.pathname, storage],
  );

  return {
    recentlyVisitedItems: key
      ? storage.snapshot<RecentlyVisitedItem[]>(key).value
      : undefined,
    triggerRecentlyVisited,
  };
}
